import {Form, Input} from 'antd';
import React, {FC} from 'react';

import {CustomSelect} from 'components/form/inputs/custom-select';
import {IDescriptiveFlexfieldSegment} from 'store/slices/descriptive-flexfields-slice/descriptive-flexfields-slice-types';

interface ISegmentResolverComponentProps {
    segment?: IDescriptiveFlexfieldSegment;
    options?: {
        isDisabled?: boolean;
        mode?: 'create' | 'read';
    };
}

export const SegmentResolverComponent: FC<ISegmentResolverComponentProps> = (
    {segment, options = {}}: ISegmentResolverComponentProps,
) => {
    const {isDisabled, mode} = options;

    if (!segment?.displayed) return null;
    return (
        <Form.Item
            rules={[{required: segment?.required}]}
            label={segment.segmentUserName}
            name={segment.segmentColumnName.toLowerCase()}
        >
            {
                (() => {
                    const {valuesetLookup} = segment;
                    if (valuesetLookup && valuesetLookup.simpleListFlag) {
                        return (
                            <CustomSelect
                                settings={{
                                    isDisabled: isDisabled || !segment.enabled,
                                    placeholder: mode === 'create' ? 'Выберите значение' : 'Значение не задано',
                                    isClearable: !segment?.required,
                                    showNullValueAsUndefined: true,
                                    showEmptyStringAsUndefined: true,
                                    setNullInsteadOfUndefinedOnChange: true,
                                }}
                                entries={valuesetLookup
                                    .values
                                    .map(({meaning, lookupCode}) => ({
                                        label: meaning,
                                        value: lookupCode,
                                    })) ?? []}
                            />
                        );
                    }
                    return (
                        <Input
                            disabled={isDisabled || !segment.enabled}
                            placeholder={mode === 'create' ? 'Введите значение' : 'Значение не задано'}
                        />
                    );
                })()
            }

        </Form.Item>
    );
};
